import Vue from 'vue';
import vuescroll from 'vuescroll';

// custom plugins
import Axios from './plugins/Axios.js';
import SbIcons from './plugins/SbIcons';
import Vuetify from './plugins/Vuetify.js';
import SbBaseUrl from './plugins/SbBaseUrl.js';
import tableLength from './plugins/TableLength.js';

import MainLayout from './layouts/MainLayout.vue';
import Login from '../vue/pages/Login.vue';
import AuthSuccessErrorPage from '../vue/pages/AuthSuccessErrorPage.vue';
import SbPanel from './components/SbPanel.vue';
import SbMetricTiles from './components/SbMetricTiles.vue';

import { default as globalStore } from './store/Global.js';

// Global component registration
Vue.component('SbPanel', SbPanel);
Vue.component('SbMetricTiles', SbMetricTiles);

// instance configuration
Vue.config.devtools = true;

// instance plugins
Vue.use(Axios);
Vue.use(SbIcons);
Vue.use(Vuetify);
Vue.use(SbBaseUrl);
Vue.use(tableLength);
Vue.use(vuescroll, {
  ops: {
    // The global config
  },
  name: 'myScroll', // customize component name, default -> vueScroll
});

/**
 * Get a Vue instance for a module
 * @param {string} title The title of the module
 * @param {VueRouter} router The router for the module
 * @param {VuexStore} store The store for the module
 * @param {string} wrapperClass A class to wrap the module with
 * @param {bool} isHomePage Whether or not this is the home page
 * @returns A Vue instance, which can then be used to call `$mount` on
 */
export const getModuleWrapper = (
  title,
  router,
  store = globalStore,
  wrapperClass = undefined,
  isHomePage = false
) => {
  return new Vue({
    router,
    store,
    render: (h) => {
      if (router.currentRoute.meta.layout === 'ErrorLayout') {
        return h('div', {}, [h('router-view')]);
      } else {
        return h(MainLayout, {
          props: {
            title,
            wrapperClass,
            isHomePage,
          },
        });
      }
    },
  });
};

export const loginWrapper = (
  title,
  router,
  returnUrl = null,
  authApiUrl = null,
  store = globalStore
) => {
  return new Vue({
    router,
    store,
    render: (h) => {
      if (router.currentRoute.meta.layout === 'ErrorLayout') {
        return h('div', {}, [h('router-view')]);
      } else {
        return h(Login, {
          props: {
            title,
            returnUrl,
            authApiUrl,
          },
        });
      }
    },
  });
};

export const moduleWrapper = (title, router, store = globalStore) => {
  return new Vue({
    router,
    store,
    render: (h) => {
      if (router.currentRoute.meta.layout === 'ErrorLayout') {
        return h('div', {}, [h('router-view')]);
      } else {
        return h(AuthSuccessErrorPage, {
          props: {
            title,
          },
        });
      }
    },
  });
};
